module.exports = __webpack_public_path__ + "assets/img/68_725_2.95fd2917.jpg";